const DISTANCE_EPSILON = 0.00001;

export default DISTANCE_EPSILON;
